import styled, { css } from 'styled-components';
import { getFontSize } from '../../../../utils/getFont';

export const Inner = styled.div`
  position: relative;
  text-align: center;
  width: 100%;
`;

const commonStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > h2 {
    font-family: var(--text-cursive);
    ${getFontSize(10)}
    margin-bottom: 0.5rem;
  }

  h4 {
    margin: 0;
  }

  p {
    font-family: var(--text-normal);
    ${getFontSize(2)}
  }

  > div {
    margin-bottom: 1rem;
  }
`;

export const Content = styled.div`
  background-color: var(--background-alt);
  padding: 100px 2rem 0;
  min-height: 300px;

  ${commonStyles}

  p {
    margin-bottom: 2rem;
  }

  .radio-attendance {
    margin: 1rem 0;
  }

  > p > span {
    font-weight: bold;
    ${getFontSize(4)}
  }
`;

export const Extra = styled.div`
  background-color: var(--background);
  width: 100%;
  border-radius: 8px;
  padding: 1rem 1rem 0;
  margin-top: 1rem;

  ${commonStyles}

  *, input {
    background: transparent;
  }
`;

export const BorderBottom = styled.div`
  position: relative;
  height: 80px;
`;

export const CloseButton = styled.div`
  height: 25px;
  margin-left: 2rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: underline;
`;

export const Label = styled.label`
  color: var(--text);
  ${({ fontSize }) => getFontSize(fontSize)}
  text-align: left;
  margin-top: 4rem;

  b {
    display: block;
    ${({ fontSize }) => getFontSize(fontSize + 1)}
    margin-bottom: 1rem;
  }

  span {
    display: block;
    font-weight: bold;
    margin-top: 0.75rem;
  }
`;

export const PhonesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  gap: 20px;
  margin-top: 30px;
  margin-bottom: 10px;

  > div {
    ${getFontSize(2)}

    span {
      font-family: var(--text-cursive);
      ${getFontSize(5)}
      margin-right: 10px;
    }

    display: flex;
    align-items: baseline;
    margin-bottom: 10px;

    div {
      display: flex;
      align-items: center;
    }
  }

  a {
    color: var(--text);
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      text-decoration: underline;
    }
  }

  @media (max-width: 470px) {
    flex-direction: column;
    align-items: center;
    gap: 0;

    > div {
      margin-bottom: 1rem;
    }
  }
`;
